module.exports = __webpack_public_path__ + "static/stepankova-1cb07e5628c49c4111d888ecaf7e6596.jpg";